var React = require('react');

function IconArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3l-7.5 7.5 1.06 1.06 5.69-5.69V21h1.5V5.87l5.7 5.69 1.05-1.06L12 3z"}));
}

IconArrowUp.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconArrowUp;

IconArrowUp.default = IconArrowUp;
